import { useState } from 'react';

export default function Hero() {
  const scrollToForm = () => {
    const formSection = document.getElementById('contact-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0d217e237f1de33018f7ebc742ed832d.jpg"
          alt="Luxury Tour Bus"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-900/90 to-blue-900/70"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-6 left-6 z-20">
        <img
          src="https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/82ae3b2df0f0ac62ff8972fa7a8d315b.png"
          alt="America Discovery Logo"
          className="h-12 sm:h-16 md:h-20 w-auto"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20">
        <div className="max-w-3xl">
          <h1 className="text-3xl sm:text-5xl md:text-5xl lg:text-6xl font-extrabold text-white mb-8 leading-tight" style={{ textShadow: '0 4px 12px rgba(0,0,0,0.8), 0 2px 4px rgba(0,0,0,0.6)' }}>
            DỊCH VỤ VẬN TẢI DU LỊCH TẠI MỸ
            <br className="sm:hidden" />
            CHO CÁC CÔNG TY DU LỊCH VIỆT NAM
          </h1>
          
          <p className="text-xl sm:text-2xl md:text-2xl text-white mb-10 leading-relaxed font-bold" style={{ textShadow: '0 3px 8px rgba(0,0,0,0.8), 0 2px 4px rgba(0,0,0,0.6)' }}>
            Xe từ 7–15-25-36-56 chỗ – Lái xe tiếng Việt &amp; tiếng Anh – Giá linh hoạt – Chất lượng Mỹ – Phục vụ tại toàn bộ các bang miền Đông &amp; Tây Hoa Kỳ.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={scrollToForm}
              className="whitespace-nowrap bg-red-600 hover:bg-red-700 text-white px-8 sm:px-8 py-5 sm:py-5 rounded-lg text-xl sm:text-lg font-extrabold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-file-list-3-line mr-2 text-2xl"></i>
              Nhận báo giá chi tiết
            </button>
            
            <button
              onClick={scrollToForm}
              className="whitespace-nowrap bg-green-600 hover:bg-green-700 text-white px-8 sm:px-8 py-5 sm:py-5 rounded-lg text-xl sm:text-lg font-extrabold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-qr-code-line mr-2 text-2xl"></i>
              Zalo Kết Nối Nhanh
            </button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
